module.exports = __webpack_public_path__ + "img/schedule-mail.4b84dd6e.png";